// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Gq5g5id9dgoEYP {
  display: flex;
  align-items: center;
  margin-top: 4px;
  margin-bottom: 28px;
}
.tJYRrLr47_YNKb {
  display: inline-block;
  margin-right: 8px;
}
.xEUNnYesFruCvz {
  margin-top: 20px;
}
.lTj6ZMV4fQCRsv {
  color: var(--ds-text-subtle, #44546f);
}
.FrDVnS9ZwcyU3n {
  margin: 0;
  color: var(--ds-text, #172b4d);
  font-size: medium;
}
.UMgf0FKSEdGhCx {
  margin: 0;
  color: var(--ds-text-subtle, #44546f);
}
@media screen and (max-width: 450px) {
  .Gq5g5id9dgoEYP {
    display: block;
  }
  .lTj6ZMV4fQCRsv,
  .FrDVnS9ZwcyU3n,
  .UMgf0FKSEdGhCx {
    text-align: center;
  }
  .tJYRrLr47_YNKb {
    display: flex;
    justify-content: center;
  }
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"memberInfoContainer": `Gq5g5id9dgoEYP`,
	"memberAvatar": `tJYRrLr47_YNKb`,
	"innerContainer": `xEUNnYesFruCvz`,
	"description": `lTj6ZMV4fQCRsv`,
	"fullName": `FrDVnS9ZwcyU3n`,
	"email": `UMgf0FKSEdGhCx`
};
export default ___CSS_LOADER_EXPORT___;
